import * as React from 'react';
import { useMediaQuery } from '@material-ui/core';
import {
  ShowButton,
  List,
  Datagrid,
  TextField,
  EditButton,
  SimpleList,
  Filter,
  BooleanInput,
} from 'react-admin';

const UsersFilter = (props) => {
  console.log(props.data);
  return (
    <Filter {...props}>
      {props.data && (
        <h3 alwaysOn>
          Total: {Object.values(props.data).length}, Deleted:{' '}
          {
            Object.values(props.data).filter((x) => x.status === 'deleted')
              .length
          }
          , Women:{' '}
          {
            Object.values(props.data).filter(
              (x) => x.gender === 'Woman' && x.status === 'verified'
            ).length
          }
          , Men:{' '}
          {
            Object.values(props.data).filter(
              (x) => x.gender === 'Man' && x.status === 'verified'
            ).length
          }
          , Failed:{' '}
          {
            Object.values(props.data).filter((x) => x.status === 'failed')
              .length
          }
        </h3>
      )}
      <BooleanInput source="isFake" label="Real Only" alwaysOn />
    </Filter>
  );
};

const userRowStyle = (record, index) => {
  switch (record.status) {
    case 'verified':
      return {
        backgroundColor: '#eeffee ',
      };
    case 'failed':
      return {
        backgroundColor: '#cbce90   ',
      };
    case 'deleted':
      return {
        backgroundColor: '#ea887a ',
      };
    default:
      return {
        backgroundColor: '#white',
      };
  }
};

export const UserList = (props) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <List
      title="All users"
      {...props}
      filter={{
        userId: localStorage.getItem('userId'),
        type: 'all',
      }}
      filters={<UsersFilter />}
      filterDefaultValues={{ isFake: true }}
    >
      {isSmall ? (
        <SimpleList
          primaryText={(record) => record.name}
          secondaryText={(record) => record.isFaceVerificated}
          tertiaryText={(record) => record.id}
        />
      ) : (
        <Datagrid rowStyle={userRowStyle}>
          <TextField source="id" />
          <TextField source="name" />
          <TextField source="isFaceVerificated" />
          <TextField source="status" />
          <TextField source="weight" />
          <TextField source="gender" />
          <TextField source="vipExpiredAt" />
          <TextField source="lastSeen" />
          <TextField source="diamond" />
          <EditButton />
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
